import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {createSelector, Store} from '@ngrx/store';
import {
  fetchCampaignAffiliates,
  deleteCampaignAffiliate,
  addCampaignAffiliate,
  updateCampaignAffiliate,
  getCampaignAffiliate,
  fetchCampaignAffiliatesByComGroup,
  unsubscribeCampaign
} from '../../store/campaign-affiliate/campaign-affiliates.action';
import { getcampaignAffiliatesSelector, getcampaignAffiliateSelector } from '@store/campaign-affiliate/campaign-affiliates.selectors';
import { IState } from '@models/index';

import { HelperService } from '../helper/helper.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignAffiliatesService {
  backendUrl = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private store: Store<{ campaignAffiliates: IState }>
  ) {}

  getCampaignAffiliatesSelector(): Observable<IState> {
    return this.store.select(getcampaignAffiliatesSelector);
  }

  getCampaignAffiliateSelector(): Observable<IState> {
    return this.store.select(getcampaignAffiliateSelector);
  }

  fetchCampaignAffiliates(page: number, campaignID: string, filterOptions: any) {
    this.store.dispatch(fetchCampaignAffiliates({ page, campaignID, filterOptions }));
  }

  fetchCampaignAffiliatesByComGroup(page: number, campaignID: string, commissionGroupID: string = '') {
    this.store.dispatch(fetchCampaignAffiliatesByComGroup({ page, campaignID, commissionGroupID }));
  }

  fetchCampaignAffiliate(id: string) {
    this.store.dispatch(getCampaignAffiliate({ id }));
  }

  deleteCampaignAffiliate(id: string) {
    this.store.dispatch(deleteCampaignAffiliate({ id }));
  }

  addCampaignAffiliate(campaignAffiliate: any) {
    return this.store.dispatch(addCampaignAffiliate({ campaignAffiliate }));
  }

  dispachUnsubscribeCampaign(campaignAffId: any) {
    return this.store.dispatch(unsubscribeCampaign({id: campaignAffId}));
  }

  updateCampaignAffiliate(campaignAffiliate: any) {
    this.store.dispatch(updateCampaignAffiliate({ campaignAffiliate }));
  }

  getCampaignAffiliates(page: number, campaignID: string, filterOptions: any = { }) {
    const queryparams = { ...{ page }, ...filterOptions };
    const queryString = HelperService.generateQueryParams(queryparams);

    return this.http.get(`${this.backendUrl}/affiliates/campaign/${campaignID}/affiliate?${queryString}`);
  }

  getCampaignAffiliatesByComGroup(page: number, campaignID: string, commissionGroupID: string) {
    return this.http.get(`${this.backendUrl}/affiliates/campaign/${campaignID}/commission/${commissionGroupID}/affiliate?page=${page}`);
  }

  getCampaignAffiliate(id: string) {
    return this.http.get(`${this.backendUrl}/campaigns/campaign/affiliate/${id}`);
  }

  removeCampaignAffiliate(id: string) {
    return this.http.delete(`${this.backendUrl}/campaigns/campaign/affiliate/${id}`);
  }

  insertCampaignAffiliate(campaignAffiliate: any) {
    return this.http.post(`${this.backendUrl}/campaigns/campaign/get-involve`, campaignAffiliate);
  }

  renewCampaignAffiliate(campaignAffiliate: any) {
    return this.http.patch(`${this.backendUrl}/campaigns/campaign/affiliate/${campaignAffiliate.id}`, campaignAffiliate)
  }

  unsubscribeCampaign(id: number) {
    return this.http.delete(`${this.backendUrl}/campaigns/campaign/campaign-affiliate/${id}/unsubscribe`);
  }
}
